export let ModuleHideRelease = [
    "Rule",
    "GameRule",
    "DailySign",
    "FirstCharge",
    "VideoReward",
    "FriendModule",
    "Chat",
    "Bag",
    "DayWelFareModule",
    "Shop",

    "ClubList",
    "MailModule",
    "ClubPromotion",
    "ClubBank"
]

export let packageIncludeModules = {
    "BPZD": ["BiPaiTableModule", "BiPaiGoldOneGameResultModule"],
    "BP": ["BiPaiTableModule", "BiPaiGoldOneGameResultModule"],
    "JD": ["JdPokerTable"],
    "YXX": ["YXXTableModule", "RoadMap_yxx"],
    "TB": ["YXXTableModule", "RoadMap_tb"],
    "DZPK": ['TexasPokerTable'],
    "LHD": ["LongHuDouTableModule", "RoadMapInfo"],
    "QZNN": ["BankerBullBullTableModule"],
    "HJK": ["BlackJackTableModule"],
    'JK': ['K9TableModule'],
    "CP": ["CpTableModule"],
    "SLOT": ["SlotTableModule"],
    "BJL" :  ["BJLTableModule", "BJLRoadMapInfo"],
    "Q2" :  ["Q2TableModule", "Q2TableResultModule"],
}

export let allwaysInMemory = [   
    'LoadingModule'
    'NetPrompt',
    'Dialog',
    'Toast',
    'Hall',
    // 'HallBase',
    // 'WebFullScreen',
    'GoldEntranceModule',
    'GoldEntranceMatching',
    'ChatShowEmoji',
    'InsideTaskModule',

    'ClubHallModule',
    'ClubNotice',
    
    "PlayerEffectModule",
    "GameMorePanel",
    "DialogLeave",

] 